import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';
import TextNew from '@cartwhl/ui/base/TextNew';
import useMediaQuery from '@cartwhl/ui/hooks/useMediaQuery';
import CheckmarkIcon from '@cartwhl/ui/icons/CheckmarkIcon';

import { CDN } from 'consts';

import {
  type PluginFeature,
  pluginHeroVideoDesktop,
  pluginHeroVideoMobile,
} from '../integrationsPageData';

interface PluginFeaturesSectionProps {
  features: PluginFeature[];
}

function FeatureCard({ title, description }: PluginFeature) {
  return (
    <div className="bg-primary flex flex-col gap-4 rounded-2xl px-6 py-6 min-[720px]:flex-row min-[720px]:items-start min-[720px]:gap-6 min-[960px]:flex-col min-[960px]:gap-4">
      <div className="flex min-w-0 items-center gap-3 min-[720px]:basis-1/2 min-[960px]:basis-auto">
        <span className="bg-green-60 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg">
          <CheckmarkIcon className="h-5 w-5 text-white" />
        </span>
        <TextNew
          as="h3"
          token={{ base: '20/medium', lg: '24/medium' }}
          className="text-pretty"
        >
          {title}
        </TextNew>
      </div>
      <TextNew
        as="p"
        token={{ base: '14', lg: '16' }}
        className="text-secondary min-w-0 text-pretty min-[720px]:basis-1/2 min-[960px]:basis-auto"
      >
        {description}
      </TextNew>
    </div>
  );
}

export default function PluginFeaturesSection({
  features,
}: PluginFeaturesSectionProps) {
  const isDesktopVideo = useMediaQuery('(min-width: 720px)');

  return (
    <section className="container flex flex-col gap-8 min-[960px]:gap-10">
      <TextNew
        as="h2"
        token={{ base: 'sans/24/medium', lg: 'sans/36/medium' }}
        className="text-pretty"
      >
        Capture, generate and retarget — without leaving your DCC
      </TextNew>

      <div className="bg-secondary border-primary flex flex-col gap-6 rounded-2xl border px-4 py-6 min-[720px]:gap-8 min-[720px]:px-6 min-[720px]:py-8 min-[960px]:px-10 min-[960px]:py-10">
        <div className="grid grid-cols-1 gap-4 min-[960px]:grid-cols-3 min-[960px]:gap-6">
          {features.map((feature) => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>

        <div className="aspect-square overflow-hidden rounded-2xl min-[720px]:aspect-video">
          <Video
            key={isDesktopVideo ? 'desktop' : 'mobile'}
            src={`${CDN}${isDesktopVideo ? pluginHeroVideoDesktop : pluginHeroVideoMobile}`}
            className="h-full w-full"
            mode="autoplay"
            inViewThreshold={0.1}
          />
        </div>
      </div>
    </section>
  );
}
